import { http } from '@/api/http';
import { ApiResponseBody } from '@/api/types';
import { OpoOrganization, PatchOpoOrganizationRequestBody } from '@/api/apis/opo/opo.types';
import { getOpobffOrganizationApiUrl } from './opobff-organization.paths';

const getOrganization = async (): Promise<OpoOrganization> => {
  const res = await http.get<ApiResponseBody<OpoOrganization>>(getOpobffOrganizationApiUrl.organization());
  return res.data.data;
};

const updateOrganization = async (body: PatchOpoOrganizationRequestBody) => {
  const res = await http.patch<ApiResponseBody<void>>(getOpobffOrganizationApiUrl.organization(), body);
  return res.data;
};

export const opobffOrganizationApiFetcher = {
  getOrganization,
  updateOrganization,
};
